module.exports = {"id":"213388","name":"Flavien Tait","rating":"71","photo":"./data/images/photos/0/213388.png","club":{"name":"Angers SCO","logo":"./data/images/clubs/AngersSCO.png"},"positions":["MD","MC","MOC","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FlavienTait0.json
// module id = 1443
// module chunks = 0